import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, copies, Modal, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'

import * as Styles from './styles'

const ExchangeNotAllowedModal = ({ show, onClose }) => {
  const { t, i18n } = useTranslation()
  const { context } = useContext(AppContext)
  const customMessages = context.merchantInfo?.preferences?.custom_messages

  const getTitle = () => {
    const defaultTitle = copies[i18n.language].errors.exchangeNotAllowed.title
    const customTitle = customMessages?.[i18n.language]?.find(
      customReason => customReason.key === `error.exchange_not_allowed`
    )?.title

    return customTitle || defaultTitle
  }

  const getMessage = () => {
    const defaultMessage = copies[i18n.language].errors.exchangeNotAllowed.plainText()
    const customMessage = customMessages?.[i18n.language]?.find(
      customReason => customReason.key === `error.exchange_not_allowed`
    )?.message

    return customMessage || defaultMessage
  }

  return (
    <Modal size="m" title={getTitle()} show={show} onClose={onClose}>
      <Styles.Container>
        <Text type="bodyMRegular">{getMessage()}</Text>
        <Button onClick={onClose}>{t('Entendido')}</Button>
      </Styles.Container>
    </Modal>
  )
}

export default ExchangeNotAllowedModal
